import { Button } from 'b3';
import Bubble from 'b3/bubble/NewBubble';
import { withOpenC3Modal } from 'c3';
import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import { openModal } from '../../actions/ModalActions';
import ContactForm from '../contact-form/ContactForm';
import ContactCard from './ContactCard';
import './contactCard.less';

@connect(
	state => ({}),
	{ openModal }
)
@withOpenC3Modal
export default class ContactCardDropdown extends React.Component {
	static propTypes = {
	    selected: T.object,
	    contacts: T.array.isRequired,
	    onChange: T.func.isRequired
	};
	constructor(props) {
        super(props);

        this.state = {
        	selectedContactId: props.selectedContactId
        };
	}
	componentWillReceiveProps(nextProps) {
        if(nextProps.selectedContactId != this.props.selectedContactId) {
        	this.setState({
        		selectedContactId: nextProps.selectedContactId
        	});
        }
	}
	onCreatedContact(selectedContactId) {
		this.setState({
			selectedContactId
		});
		this.props.onChange(selectedContactId);
	}
	async showCreateContactModal(e) {
		e.preventDefault();

		var createdContact = await this.props.openc3Modal(
			<ContactForm clientId={this.props.clientId} />,
			{title: 'Add contact', icon: 'user-add-2'}
		);

		this.onCreatedContact(createdContact.id);
	    this.setState({ bubbleShown: false });
	}
	handleMenuItemClick(contact) {
		var selectedContactId = contact.id;
		this.setState({
			selectedContactId,
			bubbleShown: false,
		});

		this.props.onChange(selectedContactId);
	}
	handleCaretClick() {
		this.setState({ bubbleShown: true });
	}
	openEditModal(contact) {
		this.props.openc3Modal(
			<ContactForm clientId={this.props.clientId} {...contact} />,
			{title: 'Edit Contact', icon: 'user-add-2'}
		);
	}
	render() {
		var { contacts } = this.props;
		var { selectedContactId } = this.state;

		if(! contacts.length) {
			return(
				<Button
					type="success"
					className="contactCard__add"
					onClick={this.showCreateContactModal.bind(this)}
				>
					Add New Contact
				</Button>
			);
		}

		var selectedContact = contacts.find(c => c.id == selectedContactId);

		return (
			<div>
				<ContactCard
					contact={selectedContact}
					onClick={this.handleCaretClick.bind(this)}
					ref={ el => this.button = el }
					showCaret={true}
				/>

				{this.state.bubbleShown &&
					<Bubble position="top" target={this.button} className="contactCard__dropdown" onOutsideClick={o => {this.setState({ bubbleShown: false })}}>
						<div className="scroll-container">
							{contacts.filter(c => c.id != selectedContactId).map((contact, i) => 
								<ContactCard
									openEditModal={this.openEditModal.bind(this, contact)}
									canEdit={true}
									contact={contact}
									onClick={this.handleMenuItemClick.bind(this)}
									key={i}
									style={{cursor: "pointer"}}
								/>
							)}

							<Button
								type="success"
								className="contactCard__add"
								onClick={this.showCreateContactModal.bind(this)}
							>
								Add New Contact
							</Button>
						</div>
					</Bubble>
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/contact-card/ContactCardDropdown.js